export default __webpack_public_path__ + "static/media/InterviewerStats.9233bbd9.svg";